import { render } from "./CheckIcon.vue?vue&type=template&id=65c8e4ab&scoped=true"
const script = {}

import "./CheckIcon.vue?vue&type=style&index=0&id=65c8e4ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c8e4ab"]])

export default __exports__